import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEDISCOUNT = gql`
  mutation removeDiscount($id: ID!) {
    removeDiscount(id: $id)
  }
`;

function DeleteDiscount({ id, children, onDeleteDiscount, closeDrawer }) {
  const [runDeleteDiscount, deleteDiscount] = useMutation(DELETEDISCOUNT, {
    onCompleted({ removeDiscount }) {
      
      if (removeDiscount) {
        message.success(`تخفیف حذف شد.`);
        onDeleteDiscount();
        closeDrawer();
      } 
    },
    onError(err) {
      console.log(err.message);
    },
  });

  const doDeleteDiscount= () => {
    runDeleteDiscount({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={"حذف تخفیف؟"}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteDiscount}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteDiscount;
